import React from 'react';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';

import VerificationResent from './VerificationResent';
import VerificationNeeded from './VerificationNeeded';
import s from './VerificationReminder.scss';

export interface Props {
  email: string;
  isUnverified?: boolean;
  isResendInProgress: boolean;
  isEmailChangeInProgress: boolean;
  isSendingDone: boolean;
  resendEmail: () => void;
  hideChangeEmail?: boolean;
}

export const VerificationReminder: React.FC<Props> = ({
  email,
  isUnverified,
  resendEmail,
  isEmailChangeInProgress,
  isResendInProgress,
  isSendingDone,
  hideChangeEmail,
}) => {
  return (
    <ThemeOverride themeSurface={ThemeSurface.TERTIARY} className={s['container']} tag="div">
      {isSendingDone ? (
        <VerificationResent email={email} />
      ) : (
        <VerificationNeeded
          {...{
            email,
            isUnverified,
            resendEmail,
            isEmailChangeInProgress,
            isResendInProgress,
            hideChangeEmail,
          }}
        />
      )}
    </ThemeOverride>
  );
};
VerificationReminder.displayName = 'VerificationReminder';

export default VerificationReminder;
